// extracted by mini-css-extract-plugin
module.exports = {"Btn":"Button_Btn__3YSSu","BtnDisabled":"Button_BtnDisabled__uW6I2"};